import { render, staticRenderFns } from "./PatentsCopy.vue?vue&type=template&id=81bbc36a&scoped=true&"
import script from "./PatentsCopy.vue?vue&type=script&lang=js&"
export * from "./PatentsCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81bbc36a",
  null
  
)

export default component.exports